export class Sheet {
  id: number
  sheet_code: string
  nendo: number
  subject_code: number
  report_no: number
  name: string

  constructor(x: any){
    this.id = x.id;
    this.sheet_code = x.sheet_code;
    this.nendo = x.nendo;
    this.subject_code = x.subject_code;
    this.report_no = x.report_no;
    this.name = x.name;
  }
}

export class SheetField {
  id: number
  kind: number
  part1: string
  part2: string
  part3: string
  allot: number
  allot_cache: number
  page: number
  view_point_id: number
  scoring_type: number
  recog_type: number
  digital_correct_text: string

  constructor(x: any){
    this.id = x.id;
    this.kind = x.kind;
    this.part1 = x.part1;
    this.part2 = x.part2;
    this.part3 = x.part3;
    this.allot = x.allot;
    this.allot_cache = x.allot;
    this.page = x.page;
    this.view_point_id = x.view_point_id;
    this.scoring_type = x.scoring_type;
    this.recog_type = x.recog_type;
    this.digital_correct_text = x.digital_correct_text;
  }
}
